/* eslint-disable camelcase */
import { ElasticQuery } from "types/gql-types";
import { userLoginToken } from "utils/general-utils";

const KEY = "exportFields";

export const lastExportFields = (listId: string): string[] => {
  const value = localStorage.getItem(`${KEY}:${listId}`);
  if (value) {
    return JSON.parse(value);
  }
  return [];
};

export const saveLastExportFields = (listId: string, fields: string[]) : void => {
  localStorage.setItem(`${KEY}:${listId}`, JSON.stringify(fields));
};

type DownloadCsvOpts = {
  columns: string[];
  interestListIds: string[];
}

type SelectionQuery = {
  elastic_query: ElasticQuery | null,
  interest_ids: string[] | null
}

export const downloadCsv =
async (
  opts: DownloadCsvOpts,
  selectedPageRange: {from: number | null, to: number | null},
  selection: SelectionQuery,
): Promise<void> => {
  const token = userLoginToken();
  const fileName = `export-${Date.now()}.csv`;
  const { from, to } = selectedPageRange;

  const res = await fetch("/api/interests/dl/spreadsheet", {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      "authorization": `Bearer ${token}`,
      "filename": fileName,
    },
    body: JSON.stringify({
      "columns": opts.columns,
      "interest_list_ids": opts.interestListIds,
      ...selection,
      "page_from": from,
      "page_to": to,
      // eslint-disable-next-line new-cap
      "tz": Intl.DateTimeFormat().resolvedOptions().timeZone,
    }),

  });

  if (res.status !== 200) throw new Error("Error downloading CSV");

  const csvString = await res.text();

  const blob = new Blob([csvString], {
    type: "text/csv",
  });

  // download csv
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("style", "visibility:hidden");
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
